import type { RouterConfig } from '@nuxt/schema'

export default {} satisfies RouterConfig
